'use client';
import classNames from 'classnames';
import StatItem from './StatItem';
import { Stat } from '../types';
import { selectIsStatsLoading, selectStats } from '@/lib/redux/app.selectors';
import { useSelector } from 'react-redux';

interface StatsProps {
  className?: string;
}

const Stats = ({ className }: StatsProps) => {
  const stats = useSelector(selectStats);
  const isLoading = useSelector(selectIsStatsLoading);
  const data: Stat[] = [
    {
      title: 'Sent Msgs',
      value: stats?.p2pStats.daily_total ?? 0,
      colorClassName: 'text-success',
    },
    {
      title: 'Remaining Msgs',
      value: stats?.p2pStats.daily_remaining_contacts ?? 0,
      colorClassName: 'text-primary',
    },
    {
      title: 'Conversations',
      value: stats?.p2pStats.daily_conversations ?? 0,
      colorClassName: 'text-secondary',
    },
    {
      title: 'Active Canvassers',
      value: stats?.p2pStats.active_canvassers ?? 0,
      colorClassName: 'text-warn-800',
    },
  ];

  return (
    <div className={classNames('stats-info flex flex-col gap-2', className)}>
      {data.map((item, idx) => {
        if (idx % 2 !== 0) {
          return null;
        }

        // Render 2 items per row
        return (
          <div key={idx} className="flex gap-2">
            {/* Render 2 items */}
            {[item, data[idx + 1] ?? null].map((singleItem, sIdx) => (
              <StatItem key={sIdx} data={singleItem} isLoading={isLoading} />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default Stats;
